import React, { useState, useContext, useEffect, useRef } from "react";
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import ModalStandard from "../GeneralComponents/ModalStandard";
import InputFake from "../GeneralComponents/InputFake";
import { useNavigate } from "react-router-dom";
import InputFile from "../GeneralComponents/InputFile";

import PeriodoGraciaHiddenPreview from "./PeriodoGraciaHiddenPreview";
import HourglassLoader from "../GeneralComponents/HourglassLoader";
import { DAYS } from "../../Constants/Constants";

import { parseBoldText, toSnakeCase } from "../utils/general_utils";

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

export default function PeriodoGracia() {
  const { userSesion, setPageTitle, setDrawerHidding } =
    useContext(GeneralContext);
  const typeContingencia = "ZONAL";
  const text =
    "Este documento de <b>periodo de gracia</b> está destinado a <b>excluir la aplicación de descuentos</b> en casos de <b>circunstancias especiales</b> .";

  const [submitConfirm, setSubmitConfirm] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rbdLoading, setRbdLoading] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);

  // operadores
  const [operadores, setOperadores] = useState([]);
  const [operadoresLoading, setOperadoresLoading] = useState(false);

  const datetimeRef = useRef(null);
  const datePRef = useRef(null);
  const timePRef = useRef(null);
  const daysPRef = useRef(null);

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setEvidence(undefined);
    setFormData(getEmptyData());
    setOpen(false);
  };
  const navigate = useNavigate();
  const [modalError, setModalError] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const evidenceRef = useRef(null);
  const zonasRef = useRef(null);
  const [evError, setEvError] = useState(false);
  const [evidence, setEvidence] = useState();

  const contingenciasRef = useRef();
  const [formData, setFormData] = useState(getEmptyData());

  function getEmptyData() {
    return {
      name_emisor: userSesion.nombre,
      rut_emisor: userSesion.rut,
      nombre_colegio: "",
      id_operador: "",
      operator_name: "",
      id_zona: "",
      region: "",
      comuna: "",
      rbd: "",
      ees_managers: ["", ""],
      ees_managers_email: ["", ""],
      ees_temporal_manager_list: [""],
      ees_temporal_manager: "",
      ees_temporal_manager_email: "",
      ees_temporal_manager_nombres: "",
      ees_temporal_manager_apellidos: "",
      checked: false,
      contingencia_programada: false,
      programada_descripcion: "",
      programada_inicio_contingencia: dayjs(),
      programada_fin_contingencia: dayjs(),
      programada_hora_inicio: dayjs().hour(0).minute(0).second(0),
      programada_hora_termino: dayjs().hour(23).minute(59).second(59),
      especifica_fecha_hora_resolucion: dayjs().hour(23).minute(59).second(59),
      especifica_fecha_hora_ocurrencia: dayjs().hour(0).minute(0).second(0),
      especifica_codigo_evento: "",
      especifica_origen_falla: "Falla externa al adjudicatario",
      especifica_extension_falla: "Evento mayor",
      especifica_descripcion_falla: "",
      days: DAYS.reduce((acc, dia) => ({ ...acc, [dia]: false }), {}),
      extension: "zona",
      zonas: [],
    };
  }

  // helper por si quisieras seguir uniendo zonas en algún flujo futuro
  const mergeZonasWithFormData = (prevZonas, nuevasZonas) => {
    const merged = Array.isArray(prevZonas) ? [...prevZonas] : [];

    nuevasZonas.forEach((newZona) => {
      const idx = merged.findIndex((z) => z.id_zona === newZona.id_zona);

      if (idx === -1) {
        merged.push({
          ...newZona,
          rbd_list: [...(newZona?.rbd_list ?? [])],
        });
        return;
      }

      const zonaActual = merged[idx] ?? {};
      const actuales = Array.isArray(zonaActual.rbd_list)
        ? [...zonaActual.rbd_list]
        : [];
      const entrantes = Array.isArray(newZona.rbd_list)
        ? newZona.rbd_list
        : [];

      const yaTiene = new Set(actuales.map((x) => String(x)));
      const faltantes = [];

      for (const rbd of entrantes) {
        const k = String(rbd);
        if (!yaTiene.has(k)) {
          yaTiene.add(k);
          faltantes.push(rbd);
        }
      }

      if (faltantes.length > 0) {
        merged[idx] = { ...zonaActual, rbd_list: [...actuales, ...faltantes] };
      }
    });

    return merged;
  };

  // trae TODAS las zonas del operador y las coloca por defecto en formData.zonas
  async function getAllZones(id) {
    setRbdLoading(true);
    try {
      const response = await axios.getZonasOperador(id);
      const newZonas = response.data.zonas.map((zona) => ({
        ...zona,
        nombre_zona: `ZONA${String(zona.id_zona).padStart(2, "0")}`,
      }));

      // aquí simplemente dejamos TODAS las zonas del operador
      setFormData((prev) => ({
        ...prev,
        zonas: newZonas.map((z) => ({
          ...z,
          rbd_list: [...(z.rbd_list ?? [])],
        })),
      }));
    } catch (error) {
      console.error("Error en fetchDataZone:", error);
    } finally {
      setRbdLoading(false);
    }
  }

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      zonas: prevState.zonas.filter((_, i) => i !== index),
    }));
  };

  const handleDeleteRbd = (zonaIndex, rbdIndex) => {
    setFormData((prev) => {
      const zonas = [...(prev?.zonas ?? [])];
      const zona = zonas[zonaIndex];
      if (!zona) return prev;

      const rbd_list = Array.isArray(zona.rbd_list) ? [...zona.rbd_list] : [];
      rbd_list.splice(rbdIndex, 1);

      if (rbd_list.length === 0) {
        zonas.splice(zonaIndex, 1);
      } else {
        zonas[zonaIndex] = { ...zona, rbd_list };
      }

      return { ...prev, zonas };
    });
  };

  const handleOperadorChange = (event, newValue) => {
    if (!newValue) {
      setFormData((prev) => ({
        ...prev,
        id_operador: "",
        operator_name: "",
        zonas: [],
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      id_operador: newValue.id_operador+"",
      operator_name: newValue.nombre_operador,
      zonas: [],
    }));

    // cargar todas las zonas del operador
    getAllZones(newValue.id_operador);
  };

  const [errorMessages, setErrorMessages] = useState({
    especifica_fecha_hora_ocurrencia: "",
    especifica_fecha_hora_resolucion: "",
  });

  const setFile = (archivo) => {
    setEvError(!archivo ? true : false);
    setEvidence((prevData) => ({
      ...prevData,
      archivo,
    }));
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    const isProgramada = formData.contingencia_programada;
    const fechaInicioKey = isProgramada
      ? "programada_inicio_contingencia"
      : "especifica_fecha_hora_ocurrencia";
    const fechaFinKey = isProgramada
      ? "programada_fin_contingencia"
      : "especifica_fecha_hora_resolucion";

    const startOfMonth = dayjs().subtract(1, "month").startOf("month");

    const hasBajaLimit = false;
    const bajaLimit = null;
    const bajaDiaStr = null;

    const mensajes = {
      inicioInvalida: `La ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      } es inválida.`,
      inicioFuturo: `La ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      } no puede ser una fecha futura.`,
      inicioAntesDelMes: `La ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      } debe ser igual o posterior al primer día del mes anterior.`,
      inicioSobreBaja: hasBajaLimit
        ? `La ${
            isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
          } no puede ser posterior a la baja (${bajaDiaStr}).`
        : "",
      finInvalida: `La ${
        isProgramada ? "fecha de término" : "fecha de solución"
      } es inválida.`,
      finAntesInicio: `La ${
        isProgramada ? "fecha de término" : "fecha de solución"
      } debe ser posterior a la ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      }.`,
      finAntesDelMes: `La ${
        isProgramada ? "fecha de término" : "fecha de solución"
      } debe ser igual o posterior al primer día del mes anterior.`,
      finSobreBaja: hasBajaLimit
        ? `La ${
            isProgramada ? "fecha de término" : "fecha de solución"
          } no puede ser posterior a la baja (${bajaDiaStr}).`
        : "",
    };

    const vIni = formData[fechaInicioKey]
      ? dayjs(formData[fechaInicioKey])
      : null;

    if (!vIni || !vIni.isValid()) {
      errors[fechaInicioKey] = mensajes.inicioInvalida;
      valid = false;
    } else if (vIni.isBefore(startOfMonth)) {
      errors[fechaInicioKey] = mensajes.inicioAntesDelMes;
      valid = false;
    } else if (vIni.isAfter(dayjs()) && !isProgramada) {
      errors[fechaInicioKey] = mensajes.inicioFuturo;
      valid = false;
    } else if (hasBajaLimit && vIni.isAfter(bajaLimit)) {
      errors[fechaInicioKey] = mensajes.inicioSobreBaja;
      valid = false;
    }

    const vFin = formData[fechaFinKey]
      ? dayjs(formData[fechaFinKey])
      : null;

    if (!vFin || !vFin.isValid()) {
      errors[fechaFinKey] = mensajes.finInvalida;
      valid = false;
    } else if (vIni && vFin.isBefore(vIni)) {
      errors[fechaFinKey] = mensajes.finAntesInicio;
      valid = false;
    } else if (vFin.isBefore(startOfMonth)) {
      errors[fechaFinKey] = mensajes.finAntesDelMes;
      valid = false;
    
    } else if (hasBajaLimit && vFin.isAfter(bajaLimit)) {
      errors[fechaFinKey] = mensajes.finSobreBaja;
      valid = false;
    }

    if (
      isProgramada &&
      dayjs(formData["programada_hora_inicio"]).isAfter(
        formData["programada_hora_termino"]
      )
    ) {
      errors["programada_hora_termino"] =
        "La hora de termino debe ser posterior a la de inicio";
      valid = false;
      timePRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    } else if (
      isProgramada &&
      !Object.values(formData.days).some((value) => value)
    ) {
      errors["days"] = "Debe seleccionar al menos un día";
      daysPRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      valid = false;
    } else if (
      formData.ees_managers[0] === "Sin representante" &&
      formData.especifica_origen_falla === "Falla interna al adjudicatario" &&
      !formData.checked
    ) {
      setFormData((prev) => ({ ...prev, checked: true }));
      valid = false;
    } else if (!valid) {
      if (isProgramada) {
        datePRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        datetimeRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }

    if (formData.extension === "zona" && formData.zonas.length === 0) {
      errors["zonas"] = "Debe agregar al menos una zona";
      zonasRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      valid = false;
    }
    setErrorMessages(errors);
    return valid;
  };

  const save = async (event) => {
    event.preventDefault();
    if (loadingButton) return;
    setLoadingButton(true);

    if (!submitConfirm) {
      setSubmitConfirm(true);
      setLoadingButton(false);
      return;
    }

    if (!evidence) {
      setEvError(true);
      evidenceRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setLoadingButton(false);
      return;
    }

    setLoading(true);
    if (validateForm()) {
      handleDownloadPdf();
    } else {
      setLoading(false);
      setLoadingButton(false);
    }
  };

  const handleDownloadPdf = () => {
    setLoadingPdf(true);

    setTimeout(() => {
      const element = contingenciasRef.current;

      html2canvas(element, { scale: 2 })
        .then((canvas) => {
          setLoading(true);
          const imageData = canvas.toDataURL("image/jpeg", 1);

          const pdfWidth = 210;
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
          const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight + 7]);

          pdf.setFillColor(255, 255, 255);
          pdf.rect(0, 0, pdfWidth, pdfHeight + 140, "F");
          pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight);

          const pdfBlob = pdf.output("blob");

          const form = new FormData();
          const localFormData = {
            ...formData,
            especifica_fecha_hora_ocurrencia: formData[
              "especifica_fecha_hora_ocurrencia"
            ]
              ? formData["especifica_fecha_hora_ocurrencia"]
                  .locale("es")
                  .format("YYYY/MM/DD HH:mm:ss")
                  .toString()
              : null,
            especifica_fecha_hora_resolucion: formData[
              "especifica_fecha_hora_resolucion"
            ]
              ? formData["especifica_fecha_hora_resolucion"]
                  .locale("es")
                  .format("YYYY/MM/DD HH:mm:ss")
                  .toString()
              : null,
            programada_inicio_contingencia: formData[
              "programada_inicio_contingencia"
            ]
              ? formData["programada_inicio_contingencia"]
                  .locale("es")
                  .format("YYYY/MM/DD")
                  .toString()
              : null,
            programada_fin_contingencia: formData["programada_fin_contingencia"]
              ? formData["programada_fin_contingencia"]
                  .locale("es")
                  .format("YYYY/MM/DD")
                  .toString()
              : null,
            programada_hora_inicio: formData["programada_hora_inicio"]
              ? formData["programada_hora_inicio"]
                  .locale("es")
                  .format("HH:mm:ss")
                  .toString()
              : null,
            programada_hora_termino: formData["programada_hora_termino"]
              ? formData["programada_hora_termino"]
                  .locale("es")
                  .format("HH:mm:ss")
                  .toString()
              : null,
            evidence_list:
              evidence && evidence.archivo ? [evidence.archivo] : [],
          };

          form.append("data", JSON.stringify(localFormData));

          for (let i = 0; i < localFormData["evidence_list"].length; i++) {
            form.append("evidence", localFormData["evidence_list"][i]);
          }

          form.append("file", pdfBlob, "temp.pdf");

          axios
            .sendFilesPeriodoGracia(form)
            .then((response) => {
              setLoading(false);
              setModalError(false);
              setModalContent(
                "Documento enviado y firmado. Folio: " +
                  String(response.data.message?.id).padStart(8, "0")
              );
              setOpen(true);
            })
            .catch((error) => {
              setModalError(true);
              setModalContent("La creación del documento falló");
              setLoading(false);
            });
          setLoadingPdf(false);
          setSubmitConfirm(false);
          setLoadingButton(false);
        })
        .catch((error) => {
          console.error("Error generando el PDF:", error);
          setLoadingPdf(false);
          setLoading(false);
          setSubmitConfirm(false);
          setLoadingButton(false);
        });
    }, 0);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const codigoOptions = [
    { value: "19", label: "19 - Periodo de vacaciones" },
  ];

  useEffect(() => {
    const fetchOperadores = async () => {
      setOperadoresLoading(true);
      try {
        const res = await axios.getAllOperadores();
        const lista = res?.data ?? [];
        setOperadores(lista);

        
      } catch (error) {
        console.error("Error cargando operadores:", error);
      } finally {
        setOperadoresLoading(false);
        setDrawerHidding(false);
      }
    };

    fetchOperadores();
  }, [setPageTitle, setDrawerHidding]);

  return (
    <>
      <PageBody>
        <PageBgBlock pad="0">
          {loading ? (
            <HourglassLoader />
          ) : (
            <>
              <Box
                sx={{
                  paddingLeft: "9rem",
                  paddingRight: "9rem",
                  paddingTop: "2rem",
                }}
              >
                <Typography
                  variant="h1"
                  align="center"
                  sx={{ marginBottom: "0.24rem" }}
                >
                  PERIODO DE GRACIA
                </Typography>
                <Stack alignItems="left" justifyContent="center" spacing={2}>
                  <Box
                    justifyContent="center"
                    sx={{ display: "flex", margin: "0.2rem!important" }}
                  >
                    <Typography
                      variant="small"
                      color="inherit"
                      sx={{
                        textAlign: "center",
                        justifyContent: "center",
                        paddingY: "0",
                        marginTop: "0",
                      }}
                    >
                      N° folio:{" "}
                      <Typography
                        variant="small"
                        sx={{
                          paddingLeft: "1rem",
                          marginTop: "0",
                          color: "#FFF",
                        }}
                      >
                        {String("").padStart(8, "0")}
                      </Typography>
                    </Typography>
                  </Box>

                  <Box
                    justifyContent="center"
                    sx={{
                      maxWidth: "100%",
                      margin: "0 auto",
                      display: "flex",
                    }}
                  >
                    <Typography
                      variant="body"
                      align="center"
                      sx={{ marginBottom: "2rem" }}
                    >
                      {parseBoldText(text)}
                    </Typography>
                  </Box>
                </Stack>

                <form onSubmit={save} id="periodo_gracia">
                  <Stack spacing={4} sx={{ marginBottom: "2rem" }}>
                    <Typography
                      variant="h3"
                      color="inherit"
                      noWrap
                      sx={{ flexGrow: 1 }}
                    >
                      DATOS DEL EMISOR
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid size={6}>
                        <FormControl fullWidth variant="outlined">
                          <TextField
                            test_id={toSnakeCase("rut_emisor")}
                            disabled
                            required
                            name="rut"
                            label="Rut Emisor"
                            size="small"
                            value={formData.rut_emisor}
                            onChange={handleInputChange}
                          />
                        </FormControl>
                      </Grid>
                      <Grid size={6}>
                        <FormControl fullWidth variant="outlined">
                          <TextField
                            test_id={toSnakeCase("name_emisor")}
                            disabled
                            required
                            name="nombre"
                            label="Nombre y Apellido"
                            size="small"
                            value={formData.name_emisor}
                            onChange={handleInputChange}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Typography
                      variant="h3"
                      color="inherit"
                      noWrap
                      sx={{ flexGrow: 1 }}
                    >
                      DATOS BASE DEL PERIODO DE GRACIA
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid size={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel
                            id="especifica_codigo_evento-label"
                            sx={{ backgroundColor: "#fff", px: 0.5 }}
                          >
                            Código de evento
                            {formData.extension === "rbd" &&
                            !formData.contingencia_programada
                              ? "*"
                              : ""}
                          </InputLabel>
                          <Select
                            test_id={toSnakeCase("especifica_codigo_evento")}
                            required
                            labelId="especifica_codigo_evento-label"
                            id="especifica_codigo_evento"
                            value={formData.especifica_codigo_evento}
                            label="Código de evento"
                            size="small"
                            onChange={(event) =>
                              setFormData({
                                ...formData,
                                especifica_codigo_evento: event.target.value,
                              })
                            }
                          >
                            {codigoOptions.map((opt) => (
                              <MenuItem
                                test_id={toSnakeCase(
                                  "menu_especifica_codigo_evento_" + opt.value
                                )}
                                key={opt.value}
                                value={opt.value}
                              >
                                {opt.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <>
                      <Typography
                        variant="h3"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1 }}
                      >
                        DATOS DEL OPERADOR
                      </Typography>

                      <Grid container spacing={2}>
                        {/* Autocomplete de OPERADOR */}
                        <Grid size={12}>
                          <FormControl sx={{ minWidth: "100%" }}>
                            <Autocomplete
                              test_id={toSnakeCase("autocomplete_operador")}
                              loading={operadoresLoading}
                              loadingText="Cargando operadores..."
                              options={operadores || []}
                              value={
                                operadores.find(
                                  (op) =>
                                    String(op.id_operador) ===
                                    String(formData.id_operador)
                                ) || null
                              }
                              onChange={handleOperadorChange}
                              getOptionLabel={(option) =>
                                option?.nombre_operador || ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option?.id_operador === value?.id_operador
                              }
                              size="small"
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  test_id={toSnakeCase("operador")}
                                  label="Nombre operador"
                                  placeholder="Buscar operador"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        {/* Tabla de zonas + RBDs (todas las zonas por defecto) */}
                        <Grid size={12}>
                          <TableContainer
                            component={Paper}
                            sx={{ mb: 2, mt: 2 }}
                          >
                            <Table ref={zonasRef}>
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={{ width: "80px" }}>
                                    <IconButton
                                      test_id={toSnakeCase("delete")}
                                      onClick={() =>
                                        setFormData((prevState) => ({
                                          ...prevState,
                                          zonas: [],
                                        }))
                                      }
                                    >
                                      <RemoveCircleOutlineIcon />
                                    </IconButton>
                                  </TableCell>
                                  <TableCell sx={{ width: "80px" }}>
                                    Id Zona
                                  </TableCell>
                                  <TableCell>RBDs</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rbdLoading ? (
                                  <TableRow>
                                    <TableCell colSpan={3} align="center">
                                      Cargando zonas...
                                    </TableCell>
                                  </TableRow>
                                ) : formData.zonas.length > 0 ? (
                                  formData.zonas.map((zona, index) => (
                                    <TableRow key={index}>
                                      <TableCell>
                                        <IconButton
                                          test_id={toSnakeCase(
                                            "delete_" + index
                                          )}
                                          onClick={() =>
                                            handleDeleteRow(index)
                                          }
                                        >
                                          <RemoveCircleOutlineIcon />
                                        </IconButton>
                                      </TableCell>
                                      <TableCell
                                        sx={{ verticalAlign: "middle" }}
                                      >
                                        {zona.id_zona}
                                      </TableCell>
                                      <TableCell
                                        sx={{ verticalAlign: "middle" }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 0.5,
                                          }}
                                        >
                                          {Array.isArray(zona.rbd_list) &&
                                          zona.rbd_list.length > 0
                                            ? zona.rbd_list.map((rbd, ri) => (
                                                <Chip
                                                  key={`${zona.id_zona}-${ri}`}
                                                  label={String(rbd)}
                                                  size="small"
                                                  variant="outlined"
                                                  onDelete={() =>
                                                    handleDeleteRbd(
                                                      index,
                                                      ri
                                                    )
                                                  }
                                                  test_id={toSnakeCase(
                                                    `delete_rbd_${index}_${ri}`
                                                  )}
                                                />
                                              ))
                                            : null}
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={3} align="center">
                                      No hay zonas agregadas
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </Grid>
                    </>

                    <Typography
                      variant="h3"
                      color="inherit"
                      noWrap
                      sx={{}}
                    >
                      DETALLE DEL PERIODO DE GRACIA
                    </Typography>

                    {(typeContingencia === "ZONAL" ||
                      typeContingencia === "ESPECIFICA") && (
                      <>
                        <Grid container spacing={2} ref={datetimeRef}>
                          <Grid size={6}>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale={"es"}
                            >
                              <DateTimePicker
                                test_id={toSnakeCase(
                                  "especifica_fecha_hora_ocurrencia"
                                )}
                                sx={{ width: "100%" }}
                                label="Fecha y hora de ocurrencia"
                                value={
                                  formData.especifica_fecha_hora_ocurrencia
                                }
                                onChange={(newValue) =>
                                  setFormData({
                                    ...formData,
                                    especifica_fecha_hora_ocurrencia: newValue,
                                  })
                                }
                                minDate={dayjs()
                                  .subtract(1, "month")
                                  .startOf("month")}
                                slotProps={{
                                  textField: {
                                    required: true,
                                    size: "small",
                                    helperText:
                                      errorMessages.especifica_fecha_hora_ocurrencia,
                                    error:
                                      !!errorMessages.especifica_fecha_hora_ocurrencia,
                                  },
                                }}
                                disableFuture
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid size={6}>
                            <LocalizationProvider
                              dateAdapter={AdapterDayjs}
                              adapterLocale={"es"}
                            >
                              <DateTimePicker
                                test_id={toSnakeCase(
                                  "especifica_fecha_hora_resolucion"
                                )}
                                sx={{ width: "100%" }}
                                label="Fecha y hora de resolución"
                                value={
                                  formData.especifica_fecha_hora_resolucion
                                }
                                onChange={(newValue) =>
                                  setFormData({
                                    ...formData,
                                    especifica_fecha_hora_resolucion: newValue,
                                  })
                                }
                                minDate={
                                  formData.especifica_fecha_hora_ocurrencia
                                }
                                slotProps={{
                                  textField: {
                                    required: true,
                                    size: "small",
                                    helperText:
                                      errorMessages.especifica_fecha_hora_resolucion,
                                    error:
                                      !!errorMessages.especifica_fecha_hora_resolucion,
                                  },
                                }}
                                
                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>

                        {!loadingPdf ? (
                          <FormControl
                            sx={{ width: "100%", maxWidth: "100%" }}
                          >
                            <TextField
                              test_id={toSnakeCase(
                                "especifica_descripcion_falla"
                              )}
                              required={!formData.contingencia_programada}
                              multiline
                              minRows={4}
                              maxRows={30}
                              id="outlined-required"
                              label="Descripción de falla"
                              placeholder="Descripción de falla"
                              size="small"
                              value={formData.especifica_descripcion_falla}
                              onChange={(event) =>
                                setFormData({
                                  ...formData,
                                  especifica_descripcion_falla:
                                    event.target.value,
                                })
                              }
                            />
                          </FormControl>
                        ) : (
                          <InputFake value={formData.especifica_descripcion_falla} />
                        )}
                      </>
                    )}

                    <Box ref={evidenceRef}>
                      <InputFile
                        onFileSelect={setFile}
                        fileType="pdf"
                        placeholder="Subir evidencia (formato PDF)"
                      />
                      <Typography
                        variant="small"
                        align="left"
                        sx={{
                          marginBottom: "5px",
                          color: evError ? "red" : "#111",
                        }}
                      >
                        {evError ? "Debe adjuntar evidencia" : ""}
                      </Typography>
                    </Box>
                  </Stack>
                </form>
              </Box>
              <Stack
                sx={{
                  paddingLeft: "9rem",
                  paddingRight: "9rem",
                  paddingBottom: "3rem",
                }}
              >
                <Grid>
                  {submitConfirm ? (
                    <Grid
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      size={12}
                      sx={{ paddingBottom: "3rem" }}
                    >
                      <Alert
                        icon={false}
                        variant="filled"
                        severity="warning"
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          "& .MuiAlert-message": {
                            textAlign: "center",
                            width: "inherit",
                          },
                        }}
                      >
                        <Typography
                          variant="body"
                          color="inherit"
                          sx={{ textAlign: "center" }}
                        >
                          Revise que todos los campos tienen la información
                          correcta antes de enviar el levantamiento del
                          periodo de gracia, al clickear “Crear periodo de gracia el
                          documento queda ingresado al sistema.
                        </Typography>
                      </Alert>
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>
                <PageButtonBlack
                  form="periodo_gracia"
                  loading={loadingButton}
                >
                  Crear periodo de gracia
                </PageButtonBlack>
              </Stack>
            </>
          )}
        </PageBgBlock>
        <ModalStandard
          open={open}
          error={modalError}
          title={modalContent}
          btnText="Ir al listado"
          onClick={() => navigate("/contingencias_lista")}
          onClose={handleClose}
        ></ModalStandard>
      </PageBody>
      {true ? (
        <Box
          sx={{
            maxWidth: "100%",
            overflow: "hidden",
            position: "absolute",
            width: "1200px",
            height: "0",
          }}
        >
          <Box ref={contingenciasRef} sx={{ padding: "12px" }}>
            <PeriodoGraciaHiddenPreview
              formData={formData}
              text={text}
              evidence={evidence}
            ></PeriodoGraciaHiddenPreview>
          </Box>
        </Box>
      ) : null}
    </>
  );
}
